import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DocumentsService} from '../../services/documents.service';

import {DocumentsComponent} from './documents.component';
import {DocumentsListComponent} from './documents-list/documents-list.component';
import {DocumentsViewModalComponent} from './documents-view-modal/documents-view-modal.component';
import {CreateFolderModalComponent} from './create-folder-modal/create-folder-modal.component';
import {UploadFileModalComponent} from './upload-file-modal/upload-file-modal.component';
import {EditPermissionsModalComponent} from './edit-permissions-modal/edit-permissions-modal.component';
import {DatetimeModule} from '../../components/datetime/datetime.module';
import {DocumentsFilterComponent} from './documents-status-filter/documents-status-filter.component';
import {DocumentItemComponent} from './document-item/document-item.component';
import {ActionButtonComponent} from './document-item/action-button/action-button.component';
import {DirectoryPathComponent} from './directory-path/directory-path.component';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {PermissionsComponent} from './document-item/permissions/permissions.component';
import {PermissionsSelectComponent} from './permissions-select/permissions-select.component';
import {MoveModalComponent} from './move-modal/move-modal.component';
import {DocumentsDetailedViewComponent} from './documents-detailed-view/documents-detailed-view.component';
import {FieldsModule} from '../../components/fields/fields.module';
import {FileDropModule} from 'angular2-file-drop';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharingFormFieldsComponent} from './documents-detailed-view/sharing-form-fields/sharing-form-fields.component';
import {FileDetailsStepComponent} from './upload-file-modal/file-details-step/file-details-step.component';
import {NotificationDetailsStepComponent} from './upload-file-modal/notification-details-step/notification-details-step.component';
import {NotificationsApiService} from '../../services/api/notifications-api.service';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMultiSelectModule,
        FileDropModule,
        FieldsModule,
        NgSelectModule,
        ReactiveFormsModule,
        UtilsModule
    ],
    declarations: [
        DocumentsComponent,
        DocumentsListComponent,
        DocumentsViewModalComponent,
        CreateFolderModalComponent,
        UploadFileModalComponent,
        DocumentsFilterComponent,
        EditPermissionsModalComponent,
        DocumentItemComponent,
        ActionButtonComponent,
        DirectoryPathComponent,
        PermissionsComponent,
        PermissionsSelectComponent,
        MoveModalComponent,
        DocumentsDetailedViewComponent,
        SharingFormFieldsComponent,
        FileDetailsStepComponent,
        NotificationDetailsStepComponent
    ],
    exports: [
        DocumentsViewModalComponent
    ],
    providers: [
        DocumentsService,
        NotificationsApiService
    ]
})
export class DocumentsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/documents/documents.module.ts